module.exports = __webpack_public_path__ + "static/img/us.fae218b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/us.png
// module id = A/gd
// module chunks = 18